
export function forumScrollOffset() {
	let offset = 24;

	if (typeof document === 'undefined') {
		return offset;
	}

	const navbar = document.querySelector('#navbar');
	if (navbar) {
		const position = window.getComputedStyle(navbar).position;
		if (position === 'fixed' || position === 'sticky') {
			offset += Math.max(navbar.getBoundingClientRect().bottom, 0);
		}
	}

	return offset;
}

export function scrollToElement(el, options = {}) {
	if (!el) {
		return false;
	}

	const { behavior = 'auto', align = 'top' } = options;
	const rect = el.getBoundingClientRect();
	let top;

	if (align === 'center') {
		// Zet het element verticaal in het midden van het scherm (minder agressief)
		const elementCenter = rect.top + window.pageYOffset + rect.height / 2;
		top = elementCenter - window.innerHeight / 2;
	} else {
		// Net onder de vaste navigatie
		top = rect.top + window.pageYOffset - forumScrollOffset();
	}

	window.scrollTo({ top: Math.max(top, 0), behavior });
	return true;
}

export function scrollToForum(behavior = 'auto') {
	return scrollToElement(document.querySelector('.forum-outer-wrapper'), { behavior });
}

export function scrollToId(id, options = {}) {
	const { behavior = 'smooth', align = 'center' } = options;
	return scrollToElement(document.getElementById(id), { behavior, align });
}

const PREFIX = 'forumScroll:';

export function rememberForumScroll(key, data) {
	try {
		sessionStorage.setItem(PREFIX + key, JSON.stringify(data));
	} catch (e) {
	
	}
}

export function readForumScroll(key) {
	try {
		const raw = sessionStorage.getItem(PREFIX + key);
		return raw ? JSON.parse(raw) : null;
	} catch (e) {
		return null;
	}
}

export function clearForumScroll(key) {
	try {
		sessionStorage.removeItem(PREFIX + key);
	} catch (e) {

	}
}
